var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    { staticClass: "emd-container _highlight_header !shadow-none" },
    [
      _vm.title
        ? _c("div", { staticClass: "emd-container__header" }, [
            _c(
              "h2",
              {
                staticClass: "emd-text _size_section",
                attrs: { "data-testid": "title" },
              },
              [_vm._v(" " + _vm._s(_vm.title) + " ")]
            ),
          ])
        : _vm._e(),
      _c(
        "div",
        { class: { "emd-container__content": !_vm.removePadding } },
        [
          _vm.showAlert
            ? _c(
                "emd-alert",
                {
                  attrs: {
                    variant: "danger",
                    title: _vm.$t("account.settings.alert.error-title"),
                    "data-testid": "alert",
                  },
                  on: {
                    cancel: function ($event) {
                      _vm.showAlert = false
                    },
                  },
                },
                [
                  _c("template", { slot: "content" }, [
                    _c(
                      "div",
                      _vm._l(_vm.errors, function (error, index) {
                        return _c(
                          "p",
                          { key: index, attrs: { "data-testid": "error" } },
                          [_vm._v(" " + _vm._s(error) + " ")]
                        )
                      }),
                      0
                    ),
                  ]),
                ],
                2
              )
            : _vm._e(),
          _vm._l(_vm.formsOnShell, function (form, index) {
            return _c(
              form.name,
              _vm._b(
                {
                  directives: [
                    {
                      name: "show",
                      rawName: "v-show",
                      value: form?.show ?? true,
                      expression: "form?.show ?? true",
                    },
                  ],
                  key: index,
                  ref: form.name,
                  refInFor: true,
                  tag: "component",
                  attrs: { formOpenHoursValid: _vm.formOpenHoursValid },
                  on: {
                    "update:formOpenHoursValid": function ($event) {
                      _vm.formOpenHoursValid = $event
                    },
                    "update:form-open-hours-valid": function ($event) {
                      _vm.formOpenHoursValid = $event
                    },
                  },
                },
                "component",
                form,
                false
              )
            )
          }),
        ],
        2
      ),
      !_vm.onlyFields
        ? _c(
            "div",
            {
              staticClass: "emd-container__footer eu-justify_end",
              attrs: { "data-testid": "buttons" },
            },
            [
              _c(
                "button",
                {
                  staticClass: "emd-btn _color_primary _type_text",
                  attrs: {
                    type: "button",
                    "data-testid": "cancel",
                    disabled: _vm.isLoading,
                  },
                  on: { click: _vm.cancelForm },
                },
                [_vm._v(" " + _vm._s(_vm.$t("buttons.cancel")) + " ")]
              ),
              _c(
                "button",
                {
                  staticClass: "emd-btn _color_primary",
                  attrs: {
                    tabindex: "0",
                    "data-testid": "confirm",
                    disabled: !_vm.formOpenHoursValid,
                  },
                  on: { click: _vm.confirmForm },
                },
                [_c("span", [_vm._v(_vm._s(_vm.$t("buttons.request")))])]
              ),
            ]
          )
        : _vm._e(),
      _vm.modalPasswordIsOpen
        ? _c("modal-password", {
            attrs: {
              "data-testid": "modal-password",
              textButtonSubmit: _vm.$t("buttons.request"),
              callback: _vm.sendRequestWithPassword,
            },
            on: { cancel: _vm.hideModalPassword },
          })
        : _vm._e(),
      _vm.modalSuccessIsOpen
        ? _c("modal-success", {
            attrs: {
              "data-testid": "modal-success",
              title: _vm.successTexts.title,
              info: _vm.successTexts.info,
              content: _vm.successTexts.content,
            },
            on: {
              onCancel: _vm.handleSuccessModalButton,
              onSubmit: _vm.handleSuccessModalButton,
            },
          })
        : _vm._e(),
      _vm.modalPreValidationIsOpen
        ? _c(
            _vm.preValidation.component,
            _vm._b(
              {
                tag: "component",
                on: {
                  onCancel: function ($event) {
                    _vm.modalPreValidationIsOpen = false
                  },
                  onSubmit: _vm.handleSubmitPreValidation,
                },
              },
              "component",
              _vm.preValidation.props,
              false
            )
          )
        : _vm._e(),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }